import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';

import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';
import { specificationsService } from 'parts/services';
import {
  IPartFieldConfigs,
  IPartFieldConfigsRequestPayload,
  IPartSpecifications,
  IPartSpecificationsRequestPayload,
} from 'parts/types';

export const useGetPartSpecifications = (
  requestPayload: IPartSpecificationsRequestPayload,
  enabled = true
) => {
  const { data, isError, isLoading } = useQuery<IPartSpecifications>(
    ['partSpecifications', requestPayload],
    ({ signal }) => specificationsService.getPartSpecifications(requestPayload, signal),
    { enabled }
  );

  return { record: data, isError, isLoading };
};

export const useGetPartFieldConfigs = (
  requestPayload: IPartFieldConfigsRequestPayload,
  enabled = true
) => {
  const { data, isError, isLoading } = useQuery<IPartFieldConfigs>(
    ['partFieldConfigs', requestPayload],
    ({ signal }) => specificationsService.getPartFieldConfigs(requestPayload, signal),
    { enabled }
  );

  return { record: data, isError, isLoading };
};

export const useSavePartParticulars = ({
  position = NotificationPosition.FORM,
}: { position?: NotificationPosition } = {}) => {
  const { t } = useTranslation();

  const { errors } = useHandleErrors({
    success: { message: t('messagePartParticularsSaveSuccess') },
    loading: { message: t('messagePartParticularsSaveInProgress') },
    error: { title: t('errorTitlePartParticularsSave') },
    position,
    invalidateQueries: ['partSpecifications', 'partFieldConfigs'],
  });

  const { mutateAsync: savePartParticulars } = useMutation(
    specificationsService.savePartParticulars,
    errors
  );

  return { savePartParticulars };
};
